






























































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import SearchBarMobile from '@/components/misc/SearchBar/SearchBarMobile.vue'
import NetworkMenu from './NetworkSettings/NetworkMenu.vue'
import DayNightToggle from '@/components/misc/DayNightToggle.vue'
import {
    DEFAULT_NETWORK_ID,
    DEFAULT_NETWORK,
    DEFAULT_NETWORK_NAME,
} from '@/store/modules/network/network'

@Component({
    components: {
        SearchBarMobile,
        NetworkMenu,
        DayNightToggle,
    },
})
export default class NavbarMobile extends Vue {
    isDrawer = false
    isSearch = false
    netID = DEFAULT_NETWORK_ID.toString()

    onsearch(val: string) {
        this.$router.push({ path: '/search', query: { query: val } })
    }
    get DEFAULT_NETWORK_NAME() {
        return DEFAULT_NETWORK_NAME
    }
    get showSearch() {
        return this.$router.currentRoute.name === 'Home' ? false : true
    }

    get logoColor() {
        return DEFAULT_NETWORK_ID === 1 ? 'black' : 'white'
    }

    get currentPath() {
        return this.$route
    }

    get navColor() {
        return '#fff'
    }

    get selectedNet() {
        return this.$store.state.Network.selectedNetwork
    }

    @Watch('selectedNet')
    currentNetID() {
        if (this.selectedNet) this.netID = this.selectedNet.networkId
        else this.netID = DEFAULT_NETWORK_ID.toString()
    }

    get _actChainID() {
        return DEFAULT_NETWORK.actChainId
    }

    get _astChainID() {
        return DEFAULT_NETWORK.astChainId
    }

    get _athChainID() {
        return DEFAULT_NETWORK.athChainId
    }

    get actChainURL() {
        return `/blockchain/${this._actChainID}`
    }

    get astChainURL() {
        return `/blockchain/${this._astChainID}`
    }

    get athChainURL() {
        return `/blockchain/${this._athChainID}`
    }

    get statsURL() {
        return 'https://stats.dcm.network/' //@LINK_TO_CHANGE
    }

    get isMainnet() {
        return DEFAULT_NETWORK_ID === 1 ? true : false
    }

    get statusPageURL() {
        return DEFAULT_NETWORK.statusUrl
    }

    get explorerURL() {
        return DEFAULT_NETWORK.actChainExplorerUrl
    }

    get walletURL() {
        return DEFAULT_NETWORK.walletUrl
    }

    get faucetURL() {
        return DEFAULT_NETWORK.dcommFaucetUrl
    }

    closeSearch(val: boolean) {
        this.isSearch = val
    }
    generateURL(path: string) {
        const baseUrl = path // Base URL without query parameters
        const queryParams: { [network: string]: string } = {
            network: DEFAULT_NETWORK_NAME,
        } // Query parameters and their values

        // Generate the URL by appending the query parameters
        const url = new URL(baseUrl, window.location.origin)
        Object.keys(queryParams).forEach((key) => {
            url.searchParams.append(key, queryParams[key])
        })

        return url.toString()
    }
}
